<div
  *ngIf="gridData && gridData.title"
  [title]="gridData.title"
  class="comparison-grid-table-title"
>
  {{ gridData.title }}
</div>
<div class="comparison-grid-container" *ngIf="gridData">
  <table
    mat-table
    *ngIf="dataSource"
    [dataSource]="gridData ? dataSource : undefined"
    cellpadding="0"
    cellspacing="0"
    class="comparison-grid-table"
  >
    <ng-container matColumnDef="ticker" sticky>
      <th mat-header-cell *matHeaderCellDef>
        <div class="ticker-column col-header-title">
          Ticker ({{ dataSource.length }})
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div
          class="display-flex flex-justify-between ticker-cell"
          [ngClass]="{ 'ticker-cell-deletion': element.tickerCanBeDeleted }"
          [title]="element.ticker"
        >
          <span>
            <a
              class="no-decor"
              routerLink="{{ '/company/' + element.ticker }}"
              routerLinkActive
            >
              {{ element.ticker }}
            </a>
          </span>
          <span
            *ngIf="element.tickerCanBeDeleted"
            class="del"
            (click)="deleteTicker(element)"
          >
            <va-icon name="close" class="table-cell-cross-icon"></va-icon>
          </span>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef class="summary-title-cell"></td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th
        (click)="sortData('companyName')"
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="[
          isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
        ]"
      >
        <div class="header-container">
          <div title="Company Name" class="col-header-title">Company Name</div>
          <div
            class="column-sort-icon-container"
            [ngClass]="{ 'hide-sort-button': isDataInProgress }"
          >
            <div>
              <va-icon
                isFontAwesome="true"
                [name]="faCaretUp"
                [ngStyle]="{
                  color:
                    activeSort === 'companyName' && sortDirection === 'asc'
                      ? '#36abad'
                      : 'lightgray'
                }"
                class="column-sort-icon"
              >
              </va-icon>
            </div>
            <div>
              <va-icon
                size="small"
                name="caret-down"
                [ngStyle]="{
                  color:
                    activeSort === 'companyName' && sortDirection === 'desc'
                      ? '#36abad'
                      : 'lightgray'
                }"
                class="column-sort-icon column-sort-down-icon"
              >
              </va-icon>
            </div>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="company-name-cell-layout">
          <div class="cell-text" [title]="element['companyName']">
            {{ element.companyName }}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container *ngFor="let col of gridData.dynamicColumns">
      <ng-container [matColumnDef]="col.id">
        <th mat-header-cell *matHeaderCellDef>
          <div
            class="header-container"
            [ngClass]="[
              isDataInProgress ? 'disable-header-sort' : 'enable-header-sort',
              !col.hasSort ? 'text-align-center' : ''
            ]"
            (click)="col.hasSort ? sortData(col.id) : null"
          >
            <div [title]="col.label" class="col-header-title">
              {{ col.label }}
            </div>
            <div
              class="column-sort-icon-container"
              [ngClass]="{ 'hide-sort-button': isDataInProgress }"
              *ngIf="col.hasSort"
            >
              <div>
                <va-icon
                  isFontAwesome="true"
                  [name]="faCaretUp"
                  [ngStyle]="{
                    color:
                      activeSort === col.id && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                  class="column-sort-icon"
                >
                </va-icon>
              </div>
              <div>
                <va-icon
                  size="small"
                  name="caret-down"
                  [ngStyle]="{
                    color:
                      activeSort === col.id && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                  class="column-sort-icon column-sort-down-icon"
                >
                </va-icon>
              </div>
            </div>
          </div>

          <div
            class="subheader-container"
            *ngIf="col.subColumns && col.subColumns.length"
          >
            <div
              *ngFor="let subCol of col.subColumns"
              class="header-container"
              (click)="sortData(subCol.id)"
              [ngClass]="[
                isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
              ]"
            >
              <div class="cell-layout">
                <div class="col-subheader-title" [title]="subCol.label">
                  {{ subCol.label }}
                </div>
              </div>
              <div
                class="column-sort-icon-container"
                [ngClass]="{ 'hide-sort-button': isDataInProgress }"
                *ngIf="subCol.hasSort"
              >
                <div>
                  <va-icon
                    isFontAwesome="true"
                    [name]="faCaretUp"
                    [ngStyle]="{
                      color:
                        activeSort === subCol.id && sortDirection === 'asc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                    class="column-sort-icon"
                  >
                  </va-icon>
                </div>
                <div>
                  <va-icon
                    size="small"
                    name="caret-down"
                    [ngStyle]="{
                      color:
                        activeSort === subCol.id && sortDirection === 'desc'
                          ? '#36abad'
                          : 'lightgray'
                    }"
                    class="column-sort-icon column-sort-down-icon"
                  >
                  </va-icon>
                </div>
              </div>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="text-align-right">
          <div class="cell-container">
            <div *ngIf="!col.subColumns || !col.subColumns.length">
              <div
                *ngIf="
                  !element ||
                  (gridData.columnParentMapping[col.id]
                    ? !element[gridData.columnParentMapping[col.id]][col.id][
                        'formatted'
                      ]
                    : !element[col.id]['formatted'])
                "
                class="cell-layout"
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="
                  element &&
                  (gridData.columnParentMapping[col.id]
                    ? element[gridData.columnParentMapping[col.id]][col.id][
                        'formatted'
                      ]
                    : element[col.id]['formatted'])
                "
                class="cell-layout"
                [ngClass]="{
                  'selected-cell':
                    selectedCell ===
                    element.ticker +
                      '_' +
                      col.id +
                      '_' +
                      (gridData.columnParentMapping[col.id] || '')
                }"
                [ngStyle]="{
                  'background-color': gridData.columnParentMapping[col.id]
                    ? element[gridData.columnParentMapping[col.id]][col.id][
                        'bgColor'
                      ]
                    : element[col.id]['bgColor']
                }"
              >
                <div
                  class="cell-text"
                  [ngClass]="{
                    'negative-value': gridData.columnParentMapping[col.id]
                      ? element[gridData.columnParentMapping[col.id]][col.id][
                          'isNegative'
                        ] &&
                        !element[gridData.columnParentMapping[col.id]][col.id][
                          'bgColor'
                        ]
                      : element[col.id]['isNegative'] &&
                        !element[col.id]['bgColor']
                  }"
                  (click)="
                    onCellClick(
                      $event,
                      element.ticker,
                      col.id,
                      gridData.columnParentMapping[col.id]
                    )
                  "
                  [title]="
                    gridData.columnParentMapping[col.id]
                      ? element[gridData.columnParentMapping[col.id]][col.id][
                          'formatted'
                        ]
                      : element[col.id]['formatted']
                  "
                >
                  {{
                    gridData.columnParentMapping[col.id]
                      ? element[gridData.columnParentMapping[col.id]][col.id][
                          "formatted"
                        ]
                      : element[col.id]["formatted"]
                  }}
                </div>
              </div>
            </div>
            <ng-container *ngFor="let subCol of col.subColumns">
              <div
                *ngIf="
                  !element ||
                  !element[gridData.columnParentMapping[subCol.id]] ||
                  !element[gridData.columnParentMapping[subCol.id]][subCol.id][
                    'formatted'
                  ]
                "
                class="cell-layout"
              >
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </div>
              <div
                *ngIf="
                  element &&
                  element[gridData.columnParentMapping[subCol.id]][subCol.id][
                    'formatted'
                  ]
                "
                class="cell-layout"
                [ngClass]="{
                  'selected-cell':
                    selectedCell ===
                    element.ticker +
                      '_' +
                      subCol.id +
                      '_' +
                      gridData.columnParentMapping[subCol.id]
                }"
                [ngStyle]="{
                  'background-color':
                    element[gridData.columnParentMapping[subCol.id]][subCol.id][
                      'bgColor'
                    ]
                }"
              >
                <div
                  class=""
                  [ngClass]="{
                    'negative-value':
                      element[gridData.columnParentMapping[subCol.id]][
                        subCol.id
                      ].isNegative &&
                      !element[gridData.columnParentMapping[subCol.id]][
                        subCol.id
                      ]['bgColor']
                  }"
                  [title]="
                    element[gridData.columnParentMapping[subCol.id]][subCol.id]
                      .formatted
                  "
                  (click)="
                    onCellClick(
                      $event,
                      element.ticker,
                      subCol.id,
                      gridData.columnParentMapping[subCol.id]
                    )
                  "
                >
                  {{
                    element[gridData.columnParentMapping[subCol.id]][subCol.id][
                      "formatted"
                    ]
                  }}
                </div>
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'selected-row': selectedRow == row.ticker }"
    ></tr>
  </table>
</div>
<div *ngIf="gridData" class="comparison-container-footer">
  <div class="comparison-footer-right-section">
    <span class="magnitude-note">{{ magnitudeMessage }}</span>
    <div *ngIf="showFactsetMessage" class="factset-note">
      {{ factsetCopyRightMessage }}
    </div>
  </div>
</div>

<div *ngIf="!gridData" class="comparison-grid-loader-container">
  <ul nz-menu>
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
      class="comparison-grid-loader-list"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</div>
